module.exports = __webpack_public_path__ + "static/media/heart.0585eea7.svg";